import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const sendTask = async (prompt) => {
  try {
    const response = await api.post('/task', { prompt });
    return response.data;
  } catch (error) {
    console.error('Error sending task:', error);
    throw error;
  }
};

export const getStatus = async () => {
  try {
    const response = await api.get('/status');
    return response.data;
  } catch (error) {
    console.error('Error getting status:', error);
    throw error;
  }
};

export const getAgents = async () => {
  try {
    const response = await api.get('/agents');
    return response.data;
  } catch (error) {
    console.error('Error getting agents:', error);
    throw error;
  }
};

export default api;
